import React, { useEffect, useRef, useState } from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import { safeJsonParse } from '../utils/jsonUtils'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import {
   Box,
   Button,
   ButtonGroup,
   Divider,
   FormControl,
   Grid,
   IconButton,
   MenuItem,
   Modal,
   Select,
   TextField,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import toast from 'react-hot-toast'
import VisibilityIcon from '@mui/icons-material/Visibility'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { BeatLoader } from 'react-spinners'
import axios from '../api/axios'
import socket from '../socket'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { getDateTimeWithAmPm } from '../utils/dateUtils'
import { formatVehicleType, getVehicleModel, getBuildYear, formatRegNumber } from '../utils/vehicleType'

const columns = [
   { id: 'orderId', label: 'ID', minWidth: 100 },
   { id: 'client', label: 'Client', minWidth: 100 },
   { id: 'vehicleType', label: 'Vehicle', minWidth: 150 },
   { id: 'buildYear', label: 'Build Year', minWidth: 100 },
   { id: 'VINnumber', label: 'Reg Number', minWidth: 100 },
   { id: 'status', label: 'Status', minWidth: 50 },
   { id: 'tuningType', label: 'Tuning Type', minWidth: 100 },
   { id: 'createdAt', label: 'Upload Date', minWidth: 100 },
   { id: 'updatedAt', label: 'Last Updated', minWidth: 100 },
   { id: 'action', label: 'Action', align: 'center' },
]

// Vehicle details from the Biltema lookup, shown in the request modal
const VEHICLE_LOOKUP_FIELDS = [
   ['manufacturer', 'Manufacturer'],
   ['model', 'Model'],
   ['modelYear', 'Model Year'],
   ['engine', 'Engine'],
   ['engineCode', 'Engine Code'],
   ['powerHp', 'HP'],
   ['powerKw', 'KW'],
   ['drive', 'Drive'],
   ['gearbox', 'Gearbox'],
   ['fuel', 'Fuel'],
]

// Tuning type and extras are shown together in the Tuning Type column
const getTuningText = (row) => [row.tuningType, row.extras].filter(Boolean).join(', ')

// Vehicle column shows the vehicle type with manufacturer and model below
const getVehicleText = (row) => [formatVehicleType(row.vehicleType), getVehicleModel(row)].filter(Boolean).join(' ')

// Wraps only at spaces, never at hyphens (e.g. "5-dörrar")
const NoHyphenBreak = ({ text }) =>
   text.split(' ').map((word, i) => (
      <React.Fragment key={i}>
         {i > 0 && ' '}
         <span style={{ whiteSpace: 'nowrap', fontFamily: 'inherit' }}>{word}</span>
      </React.Fragment>
   ))

const getColumnValue = (row, columnId) =>
   columnId === 'tuningType' ? getTuningText(row) :
   columnId === 'vehicleType' ? getVehicleText(row) :
   columnId === 'buildYear' ? getBuildYear(row) :
   columnId === 'VINnumber' ? formatRegNumber(row.VINnumber) :
   row[columnId]

const style = {
   position: 'absolute',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: '90vw',
   bgcolor: 'background.paper',
   border: '0px',
   borderRadius: 1,
   boxShadow: 24,
   p: 0,
}

export default function AdminUpload() {
   const [creditsData, setCreditsData] = useState([])
   const [account,setAccount] = useState(null);
   const [page, setPage] = useState(0)
   const [myID, setMyID] = useState('')
   const [rowsPerPage, setRowsPerPage] = useState(10)
   const [uploadBtnFlag, setUploadBtnFlag] = useState(true)
   const [creditBtnFlag, setCreditBtnFlag] = useState(true)
   const [allData, setAllData] = useState([])
   const [oneData, setOneData] = useState({
      orderId: '',
      userId: '',
      client: '',
      fileSize: [],
      fileType: [],
      fileName: [],
      fileRename: [],
      vehicleType: '',
      vehicleBrand: '',
      vehicleEngine: '',
      vehicleSeries: '',
      buildYear: '',
      HP: '',
      KW: '',
      transmission: '',
      VINnumber: '',
      tuningType: '',
      extras: '',
      message: '',
      note: '',
      status: '',
      createdAt: '',
      updatedAt: '',
      uploadedAt: null,
      supportUploadedAt: null,
      lastUpdatedAt: null,
      availableCredit: 0,
      chargedCredit: 0,
   })
   const [metadata, setMetadata] = useState({ userIndicies: [], supportIndicies: [] });
   const [status, setStatus] = useState('')
   const [note, setNote] = useState('')
   const [credit, setCredit] = useState(0)
   const [serviceid, setServiceID] = useState()
   const [open, setOpen] = useState(false)
   const [activeID, setActiveID] = useState('')
   const [fileData, setFileData] = useState({})
   const [isLoading, setIsLoading] = useState(false)
   const [allowEmptyFile, setAllowEmptyFile] = useState(false);
   const inputElement = useRef('fileInput')
   /* file modal */
   const [fileOpen, setFileOpen] = useState(false)
   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
   const [searchTerm, setSearchTerm] = useState('');
   const [selectedFiles, setSelectedFiles] = useState([]);
   const files = oneData.fileName.map((_, i) => ({
      fileName: oneData.fileName[i],
      fileRename: oneData.fileRename[i],
      fileType: oneData.fileType[i],
      fileSize: oneData.fileSize[i]
   }));
   const userFiles = metadata.userIndicies.map(i => files[i]);
   const supportFiles = metadata.supportIndicies.map(i => files[i]);

   const handleSort = (columnId) => {
      setSortConfig((prevConfig) => {
         if (prevConfig.key === columnId) {
            return {
               key: columnId,
               direction: prevConfig.direction === 'asc' ? 'desc' : 'asc',
            };
         }
         return { key: columnId, direction: 'asc' };
      });
   };

   const handleCheckboxChange = (fileId) => {
      setSelectedFiles((prev) =>
         prev.includes(fileId)
         ? prev.filter((f) => f !== fileId)
         : [...prev, fileId]
      );
   };

   const handleDelete = async () => {
      try {
         const data = {
            id: oneData._id,
            filesToDelete: selectedFiles,
         };
         await axios
            .post("deleteFiles", data)
            .then((result) => {
               if (result.data.status) {
                  toast.success(result.data.data);
                  setSelectedFiles([]);
                  regetFileList( activeID )
               } else {
                  toast.success(result.data.data);
               }
            });
      } catch (error) {
         console.error(error);
         toast.error("Error deleting files");
      }
   };

   const parseDate = (value) => {
      if (!value) return null;

      // Format 1: YYYY-MM-DD (med ev. tidssuffix)
      if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
         const d = new Date(value.substring(0, 10));
         return isNaN(d) ? null : d;
      }

      // Format 2: DD-MM-YYYY (med ev. tidssuffix)
      if (/^\d{2}-\d{2}-\d{4}/.test(value)) {
         const parts = value.substring(0, 10).split('-');
         const d = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
         return isNaN(d) ? null : d;
      }

      return null;
   };

   const formatDate = (value) => {
      const date = parseDate(value);
      if (!date) return value;

      return date.toISOString().slice(0, 10); // YYYY-MM-DD
   };

   const filteredData = React.useMemo(() => {
      if (!searchTerm) return allData;
      return allData.filter((row) =>
         columns.some((column) =>
            getColumnValue(row, column.id)?.toString().toLowerCase().includes(searchTerm.toLowerCase())
         )
      );
   }, [allData, searchTerm]);

   // eslint-disable-next-line react-hooks/exhaustive-deps
   const sortedData = React.useMemo(() => {
      const getSortValue = (row, key) => {
         if (key === 'createdAt') return row.uploadedAt?.[0] ? new Date(row.uploadedAt[0]) : parseDate(row.createdAt);
         if (key === 'updatedAt') return row.lastUpdatedAt ? new Date(row.lastUpdatedAt) : parseDate(row.updatedAt ?? row.createdAt);
         return getColumnValue(row, key);
      };
      if (sortConfig.key) {
         return [...filteredData].sort((a, b) => {
            const aVal  = getSortValue(a, sortConfig.key);
            const bVal  = getSortValue(b, sortConfig.key);
            const aNum  = Number(aVal);
            const bNum  = Number(bVal);
            const aDate = aVal instanceof Date ? aVal : parseDate(aVal);
            const bDate = bVal instanceof Date ? bVal : parseDate(bVal);

            if (aDate && bDate) {
               return sortConfig.direction === 'asc'
                  ? aDate - bDate
                  : bDate - aDate;
            }

            const isNumeric = !isNaN(aNum) && !isNaN(bNum);

            if (isNumeric) {
               return sortConfig.direction === 'asc'
                  ? aNum - bNum
                  : bNum - aNum;
            }

            const aStr = String(aVal).toLowerCase();
            const bStr = String(bVal).toLowerCase();

            if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
         });
      }
      return filteredData;
   }, [filteredData, sortConfig]);

   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   useEffect(() => {
      if(typeof serviceid === 'undefined') {
         // console.log("ServiceID is not defined")
         return
      }

      const obj = creditsData.find((item) => {
         return item.id === serviceid;
      })
      if(typeof obj !== 'undefined') {
         setCredit(obj.credit)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[serviceid])

   const handleChangePage = (event, newPage) => {
      setPage(newPage)
   }

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value)
      setPage(0)
   }

   const paginatedData = sortedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
   );

   const handleFileload = () => {
      inputElement.current.click()
   }

   const getFile = async (e) => {
      setFileData(e.target.files[0])
   }

   const upload = async () => {
      if (!uploadBtnFlag)
         if (!fileData.name && !allowEmptyFile) {
            toast.error('Select a file')
            return
         }
      if (!status) {
         toast.error('Select a status')
         return
      }
      if (!creditBtnFlag) {
         if (serviceid < 0) {
            toast.error('Select a credit charge')
            return
         }
      }
      if (!isLoading) {
         setIsLoading(true)
         try {
            if (status === 'completed') {
               let params = new FormData()
               const data = {
                  id: oneData._id,
                  userId: oneData.userId,
                  orderId: oneData.orderId,
                  status,
                  note,
                  credit,
                  date: getCustomDate(),
               }
               if (fileData.name) {
                  params.append('file', fileData)
               }
               params.append('data', JSON.stringify(data))
               await axios
                  .post(`updateUpload`, params)
                  .then((result) => {
                     if (result.data.status) {
                        toast.success(result.data.data)
                        getRequests()
                        setOpen(false)
                        setFileData('')
                        setStatus('')
                        setNote('')
                        setServiceID()
                        setCredit(0)
                        socket.emit('reply', {
                           from: myID,
                           to: oneData.userId,
                           orderId: oneData.orderId,
                        })
                        setIsLoading(false)
                     } else {
                        toast.error(result.data.data)
                     }
                  })
            } else {
               const data = {
                  id: oneData._id,
                  userId: oneData.userId,
                  status,
                  note,
                  credit,
                  orderId: oneData.orderId,
               }
               await axios
                  .post(`uploadStatusSave`, {
                     data,
                  })
                  .then((result) => {
                     if (result.data.status) {
                        toast.success(result.data.data)
                        getRequests()
                        setOpen(false)
                        setStatus('')
                        setNote('')
                        setServiceID()
                        setCredit(0)
                        socket.emit('reply', {
                           from: myID,
                           to: oneData.userId,
                           orderId: oneData.orderId,
                        })
                        setIsLoading(false)
                     } else {
                        toast.error(result.data.data)
                     }
                  })
            }
         } catch (error) {
            if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
            toast.error('Ett fel uppstod. Försök igen.')
         }
      } else {
         toast.error('Loading...')
      }
   }

   const getOneRequest = async (id) => {
      try {
         await axios
            .post(`getOneRequest`, { id })
            .then((result) => {
               if (result.data.status) {
                  let data = result.data.data
                  data.availableCredit = result.data.available
                  data.chargedCredit = result.data.charged
                  setActiveID(id)
                  setOneData(result.data.data)
                  setMetadata(result.data.metadata ?? { userIndicies: [], supportIndicies: [] })
                  setStatus(data.status)
                  setNote(data.note)
                  setServiceID()
                  setCredit(0)
                  setAllowEmptyFile(false)
                  setSelectedFiles([])
                  setOpen(true)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const regetFileList = async (id) => {
      try {
         await axios
            .post(`getOneRequest`, { id })
            .then((result) => {
               if (result.data.status) {
                  setOneData(result.data.data)
                  setMetadata(result.data.metadata ?? { userIndicies: [], supportIndicies: [] })
                  setSelectedFiles([])
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const handleClose = () => {
      setOpen(false)
      setActiveID('')
   }

   const getRequests = async () => {
      try {
         await axios
            .post(`getRequests`)
            .then((result) => {
               if (result.data.status) {
                  setAllData(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const changeStatus = async (id, userId, orderId) => {
      try {
         await axios
            .post(`changeStatus`, { id })
            .then((result) => {
               if (result.data.status) {
                  toast.success(result.data.data)
                  socket.emit('reply', {
                     from: myID,
                     to: userId,
                     orderId,
                  })
                  getRequests()
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getCustomDate = getDateTimeWithAmPm

   const deleteFile = () => {
      setFileData({})
      setFileOpen(false)
   }

   const getAllPrice = async () => {
      try {
         await axios
            .post(`getAllPrice`)
            .then((result) => {
               if (result) {
                  let data = result.data.map((item)=>{
                     return {credit: item.credit, service: item.service, id: item._id}
                  })
                  data.unshift({credit: 0, service: "No charge", id: 0})
                  // console.log(data)
                  setCreditsData(data)
               } else {
                  toast.error('Internal server error')
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   useEffect(() => {
      getRequests()
      getAllPrice()
   }, [])

   useEffect(() => {
      if (status === 'completed') {
         setUploadBtnFlag(false)
         setCreditBtnFlag(false)
      } else if (status === 'in-progress') {
         setUploadBtnFlag(true)
         setCreditBtnFlag(true)
      } else {
         setUploadBtnFlag(true)
         setCreditBtnFlag(true)
      }
   }, [status])

   useEffect(() => {
      if (account) {
         setMyID(account?._id)
      }
   }, [account])

   useEffect(() => {
      if (fileData?.name) setFileOpen(true)
      else setFileOpen(false)
   }, [fileData])

   return (
      <Paper
         sx={{
            width: '100%',
            overflow: 'hidden',
            p: 3,
            overflowY: 'overlay',
         }}
      >
         <div style={{marginBottom: '10px'}}>Requests</div>
         <TextField
            label="Search and filter"
            variant="outlined"
            fullWidth
            sx={{ mb: 2, width: '300px' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
         />
         <TableContainer
            sx={{
               mt: 2,
            }}
         >
            <Table stickyHeader aria-label="sticky table">
               <TableHead>
                  <TableRow>
                     {columns.map((column) => (
                        <TableCell
                           key={column.id}
                           align={column.align}
                           style={{
                              minWidth: column.minWidth,
                              backgroundColor: '#FA870C',
                              color: 'white',
                              cursor: 'pointer',
                           }}
                           onClick={() => handleSort(column.id)}
                        >
                           {column.label}{' '}
                           {sortConfig.key === column.id && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </TableCell>
                     ))}
                  </TableRow>
               </TableHead>
               <TableBody>
                  {paginatedData.map((row) => (
                     <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row._id}
                     >
                        {columns.map((column) => {
                           let value = getColumnValue(row, column.id)
                           if (column.id === 'buildYear' && !value) value = '-'
                           return (
                              <TableCell
                                 key={column.id}
                                 align={column.align}
                              >
                                 {column.id === 'action' ? (
                                    <ButtonGroup
                                       variant="outlined"
                                       aria-label="outlined button group"
                                    >
                                       {row.status.toLowerCase() === 'requested' ? (
                                          <IconButton
                                             onClick={() =>
                                                changeStatus(
                                                   row._id,
                                                   row.userId,
                                                   row.orderId
                                                )
                                             }
                                             color="primary"
                                          >
                                             <AutoModeIcon />
                                          </IconButton>
                                       ) : (
                                          <></>
                                       )}
                                       <IconButton
                                          onClick={() =>
                                             getOneRequest(row._id)
                                          }
                                          color="primary"
                                       >
                                          <VisibilityIcon />
                                       </IconButton>
                                    </ButtonGroup>
                                 ) : column.id === 'createdAt' ? (
                                    row.uploadedAt?.[0] ? (
                                       <>
                                          {new Date(row.uploadedAt[0]).toLocaleDateString('sv-SE')}
                                          <br />
                                          <span style={{ fontSize: '0.75em', color: '#888' }}>
                                             {new Date(row.uploadedAt[0]).toLocaleTimeString('sv-SE')}
                                          </span>
                                       </>
                                    ) : (
                                       formatDate(row.createdAt)
                                    )
                                 ) : column.id === 'updatedAt' ? (
                                    row.lastUpdatedAt ? (
                                       <>
                                          {new Date(row.lastUpdatedAt).toLocaleDateString('sv-SE')}
                                          <br />
                                          <span style={{ fontSize: '0.75em', color: '#888' }}>
                                             {new Date(row.lastUpdatedAt).toLocaleTimeString('sv-SE')}
                                          </span>
                                       </>
                                    ) : (
                                       formatDate(row.updatedAt ?? row.createdAt)
                                    )
                                 ) : column.id === 'vehicleType' ? (
                                    <>
                                       {formatVehicleType(row.vehicleType)}
                                       {getVehicleModel(row) && (
                                          <>
                                             <br />
                                             <NoHyphenBreak text={getVehicleModel(row)} />
                                          </>
                                       )}
                                    </>
                                 ) : column.id === 'VINnumber' ? (
                                    value || '-'
                                 ) : column.id === 'status' ? (
                                    <span className={
                                          value.toLowerCase() === 'requested' ? 'request-status' :
                                          value.toLowerCase() === 'completed' ? 'success-status' :
                                          value.toLowerCase() === 'cancelled' ? 'cancel-status' :
                                          'progress-status'
                                       } > {
                                          value.toLowerCase() === 'in-progress' ? "In progress" :
                                          value
                                       }
                                       </span>
                                 ) : (
                                    value
                                 )}
                              </TableCell>
                           );
                        })}
                     </TableRow>
                  ))}
               </TableBody>
            </Table>
         </TableContainer>
         <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
         />
         <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style}>
               <Box
                  sx={{
                     px: 3,
                     py: 1,
                     bgcolor: '#FA870B',
                     borderRadius: 1,
                     color: 'white',
                     display: 'flex',
                     alignItems: 'center',
                     position: 'fixed',
                     width: '100%',
                  }}
               >
                  <Box>View Complete Service Request</Box>
                  <Box sx={{ flex: '1' }}></Box>
                  <Box>
                     <IconButton
                        onClick={() => {
                           handleClose()
                        }}
                     >
                        <CloseIcon sx={{ color: 'white' }} />
                     </IconButton>
                  </Box>
               </Box>
               <Box
                  sx={{
                     p: 3,
                     mt: 9,
                     height: '70vh',
                     overflowY: 'overlay',
                  }}
               >
                  <Box>
                     <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12 }}
                     >
                        <Grid
                           item
                           xs={12}
                           sm={6}
                           md={6}
                           sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '20px',
                           }}
                        >
                           <Box
                              sx={{
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                                 border: '1px dotted',
                                 borderRadius: '20px',
                                 flexDirection: 'column',
                                 p: '30px',
                                 gap: '10px',
                                 alignItems: 'center',
                              }}
                           >
                              {fileOpen ? (
                                 <Box className="select-file" mt={4}>
                                    <Box className="file-group-box">
                                       <Box className="upload-img-box">
                                          <UploadFileIcon className="upload-img-icon" />
                                       </Box>
                                       <Box className="file-info">
                                          <Box>
                                             <Box className="filename-string">
                                                {fileData?.name}
                                             </Box>
                                             <Box>
                                                {(
                                                   fileData?.size / 1000000
                                                ).toFixed(4)}{' '}
                                                MB
                                             </Box>
                                          </Box>
                                       </Box>
                                    </Box>
                                    <Box className="close-img-box">
                                       <HighlightOffIcon
                                          className="close-img-icon"
                                          onClick={() => deleteFile()}
                                       />
                                    </Box>
                                 </Box>
                              ) : (
                                 <>
                                    <Box>
                                       <CloudUploadIcon
                                          sx={{
                                             color: '#FA870B',
                                             fontSize: '70px',
                                          }}
                                       />
                                    </Box>
                                    <Box>Drag and drop your file here</Box>
                                    <Box>or</Box>
                                 </>
                              )}

                              <Box>
                                 <input
                                    ref={inputElement}
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) => getFile(e)}
                                 />
                                 <Button
                                    variant="outlined"
                                    sx={{
                                       border: '1px solid #FA870B',
                                       borderRadius: '12px',
                                       color: '#FA870B',
                                    }}
                                    disabled={uploadBtnFlag}
                                    onClick={handleFileload}
                                 >
                                    Browse File
                                 </Button>
                              </Box>
                           </Box>
                           <Box>
                              Available Credits: {oneData.availableCredit}
                           </Box>
                           <Box>Charged Credits: {oneData.chargedCredit}</Box>
                           <Box>
                              Update Status
                              <FormControl fullWidth size="small">
                                 <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                 >
                                    <MenuItem value="completed">
                                       Completed
                                    </MenuItem>
                                    <MenuItem value="in-progress">
                                       In progress
                                    </MenuItem>
                                    <MenuItem value="cancelled">
                                       Cancelled
                                    </MenuItem>
                                 </Select>
                              </FormControl>
                           </Box>
                           <Box>
                              Note
                              <TextField
                                 placeholder={
                                    oneData.chargedCredit > 0
                                       ? oneData.note === '' ? '' :
                                       `X-note : ${oneData.note}` :
                                       'Add a short note'
                                 }
                                 variant="outlined"
                                 size="small"
                                 fullWidth
                                 value={note}
                                 onChange={(e) => setNote(e.target.value)}
                              />
                           </Box>
                           <Box>
                              Charge Credits
                              <Select
                                 labelId="demo-simple-select-filled-label"
                                 id="demo-simple-select-filled"
                                 size="small"
                                 fullWidth
                                 disabled={creditBtnFlag}
                                 value={serviceid}
                                 onChange={(e) => setServiceID(e.target.value)}
                              >
                                 {creditsData.map((item, key) => {
                                    return (
                                       <MenuItem key={key} value={item.id}>{item.service + ' (' + item.credit + ' credits)'}</MenuItem>
                                    )
                                 })}
                              </Select>
                           </Box>
                           <Box>
                               <label>
                                   <input type="checkbox"
                                   checked={allowEmptyFile}
                                   onChange={(e) => setAllowEmptyFile(e.target.checked)}
                                   />File upload is not required
                               </label>
                           </Box>
                           <Box>
                              <Button
                                 variant="contained"
                                 size="small"
                                 fullWidth
                                 endIcon={<ArrowForwardIcon />}
                                 onClick={upload}
                              >
                                 {isLoading ? (
                                    <BeatLoader color="#fff" size={10} />
                                 ) : (
                                    'Upload'
                                 )}
                              </Button>
                           </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                           <Box>
                              <Box
                                 sx={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                 }}
                              >
                                 Request From ({oneData?.client})
                              </Box>
                              <Divider />
                              <Grid lineHeight={'20px'}>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>Name:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.client}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Vehicle Type:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {formatVehicleType(oneData?.vehicleType)}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 {oneData?.vehicleSeries && (
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Vehicle Series:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.vehicleSeries ? oneData.vehicleSeries : '-'}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 )}
                                 {oneData?.buildYear && (
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Build Year:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {new Date(
                                             oneData?.buildYear
                                          ).getFullYear()}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 )}
                                 {oneData?.HP && (
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>HP:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.HP}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 )}
                                 {oneData?.KW && (
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>KW:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.KW}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 )}
                                 {oneData?.transmission && (
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Transmission:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.transmission}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 )}

                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Reg Number:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.VINnumber ? formatRegNumber(oneData.VINnumber) : '-'}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 {oneData?.vehicleLookup && VEHICLE_LOOKUP_FIELDS.map(([key, label]) => (
                                 <Grid
                                    key={key}
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>{label}:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box
                                          sx={{
                                             my: '12px',
                                             overflowWrap: 'break-word',
                                          }}
                                       >
                                          {oneData.vehicleLookup[key] || '-'}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 ))}
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Tuning Type:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box
                                          sx={{
                                             my: '12px',
                                             overflowWrap: 'break-word',
                                          }}
                                       >
                                          {oneData?.tuningType ? oneData.tuningType : '-'}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>Extras:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box
                                          sx={{
                                             my: '12px',
                                             overflowWrap: 'break-word',
                                          }}
                                       >
                                          {oneData?.extras ? oneData.extras : '-'}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          Work Status:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>
                                          {oneData?.status.toLowerCase() === 'in-progress' ? "In progress" :
                                           oneData?.status.charAt(0).toUpperCase() + oneData?.status.slice(1)}
                                       </Box>
                                    </Grid>
                                 </Grid>

                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '12px' }}>Message:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box
                                          sx={{
                                             my: '12px',
                                             overflowWrap: 'break-word',
                                          }}
                                       >
                                          {oneData?.message}
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </Grid>
                              <Grid
                                 container
                                 spacing={{ xs: 2, md: 3 }}
                                 columns={{ xs: 4, sm: 8, md: 12 }}
                              >
                                 <Grid item xs={12} sm={12} md={12}>
                                    <Box
                                       sx={{
                                          my: '20px',
                                          fontSize: '20px',
                                          fontWeight: '600',
                                       }}
                                    >
                                       Upload
                                    </Box>
                                    <ul>
                                       {userFiles.map((f, i) => (
                                       <li key={i} className="file-admin-download-name">
                                          <a
                                             href={`${process.env.REACT_APP_BASE_URL}/fileService/${f.fileRename}`}
                                             download={f.fileName}
                                             title={f.fileName}
                                          >{f.fileName}</a>
                                          {oneData.uploadedAt?.length === userFiles.length && oneData.uploadedAt[i] ? (
                                             <div style={{ fontSize: '0.75em', color: '#888' }}>
                                                {new Date(oneData.uploadedAt[i]).toLocaleDateString('sv-SE')}{' '}
                                                {new Date(oneData.uploadedAt[i]).toLocaleTimeString('sv-SE')}
                                             </div>
                                          ) : oneData.createdAt ? (
                                             <div style={{ fontSize: '0.75em', color: '#888' }}>
                                                {formatDate(oneData.createdAt)}
                                             </div>
                                          ) : null}
                                       </li>
                                       ))}
                                    </ul>
                                 </Grid>
                              </Grid>
                              <Grid
                                 container
                                 spacing={{ xs: 2, md: 3 }}
                                 columns={{ xs: 4, sm: 8, md: 12 }}
                              >
                                 <Grid item xs={12} sm={12} md={12}>
                                    <Box
                                       sx={{
                                          my: '20px',
                                          fontSize: '20px',
                                          fontWeight: '600',
                                       }}
                                    >
                                       Uploaded by Support team
                                    </Box>
                                    <ul>
                                       {supportFiles.map((f, i) => (
                                       <li key={i} className="file-admin-download-name">
                                          <input
                                             type="checkbox"
                                             checked={selectedFiles.includes(f.fileRename)}
                                             onChange={() => handleCheckboxChange(f.fileRename)}
                                          />
                                          <a
                                             href={`${process.env.REACT_APP_BASE_URL}/fileService/${f.fileRename}`}
                                             download={f.fileName}
                                             title={f.fileName}
                                             style={{ marginLeft: "8px" }}
                                          >
                                             {f.fileName}
                                          </a>
                                          {oneData.supportUploadedAt?.length === supportFiles.length && oneData.supportUploadedAt[i] && (
                                             <div style={{ fontSize: '0.75em', color: '#888' }}>
                                                {new Date(oneData.supportUploadedAt[i]).toLocaleDateString('sv-SE')}{' '}
                                                {new Date(oneData.supportUploadedAt[i]).toLocaleTimeString('sv-SE')}
                                             </div>
                                          )}
                                       </li>
                                       ))}
                                    </ul>
                                    {selectedFiles.length > 0 && (
                                       <button onClick={handleDelete}>Delete selected files</button>
                                    )}
                                 </Grid>
                              </Grid>
                           </Box>
                        </Grid>
                     </Grid>
                  </Box>
               </Box>
            </Box>
         </Modal>
      </Paper>
   )
}
